












































import Multiselect from 'vue-multiselect'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { Getter, State, Mutation, Action } from 'vuex-class'

import { UI_SET_SEARCH_TERM, UI_SET_SEARCH_OPEN } from '@/store/ui/constants'
import { RootState } from '@/store/types'
import {
    EDITOR_SET_TAG_DATA,
    EDITOR_ADD_TAG,
    ENTRY_UPDATE,
    EDITOR_LOAD_TAG_OPTIONS
} from '@/store/editor/constants'
import API from '../../../../util/api/API'

/**
 * Entry tag selector
 */
@Component({ components: { Multiselect }, name: 'editor-tag-select' })
export default class EditorTagSelect extends Vue {
    /**
     * Error message to display
     *
     * No error state is used if this is null
     */
    error: string | null = null

    /**
     * Whether the user can modify the entry
     */
    @Getter
    canModify!: boolean

    /**
     * Current tags
     */
    @State((state: RootState) => state.editor.entry.tags)
    tags!: string[]

    /**
     * All available tags
     */
    @State((state: RootState) => state.editor.tagOptions)
    options!: string[]

    /**
     * Whether the current entry has already been saved or not
     */
    @State((state: RootState) => state.editor.entry.existing)
    existing!: boolean

    /**
     * Set tags for the entry
     */
    @Mutation(EDITOR_SET_TAG_DATA)
    setTags!: (value: string[]) => void

    /**
     * Register a new global tag
     */
    @Mutation(EDITOR_ADD_TAG)
    addGlobalTag!: (value: string) => void

    /**
     * Open the search results panel
     */
    @Mutation(UI_SET_SEARCH_OPEN)
    setSearchOpen!: (value: boolean) => void

    /**
     * Set the global search term
     */
    @Mutation(UI_SET_SEARCH_TERM)
    setSearchTerm!: (term?: string) => void

    /**
     * Sync entry data with the API
     */
    @Action(ENTRY_UPDATE)
    updateEntry!: () => void

    @Action(EDITOR_LOAD_TAG_OPTIONS)
    loadTagOptions!: () => Promise<void>

    mounted(): void {
        API.whenConnected(() => {
            this.loadTagOptions()
        })
    }

    /**
     * Update tags list
     */
    update(tags: string[]): void {
        this.setTags(tags)
        if (this.existing) {
            this.updateEntry()
        }
    }

    /**
     * Add a new tag to the global list, and update tags list
     */
    addTag(tag: string): void {
        this.addGlobalTag(tag)
        this.update([...this.tags, tag])
    }
}
